// frontend/src/api/client.js
import axios from 'axios';
import { useLanguageStore } from '../store/useLanguageStore';

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('vnext_auth_token');

  // 🟢 INYECCIÓN DE IDIOMA INTACTA
  try {
    const state = useLanguageStore.getState();
    const language = state ? state.language : 'es';
    config.headers['Accept-Language'] = language;
  } catch (e) {
    config.headers['Accept-Language'] = 'es';
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use((response) => {
  return response;
}, (error) => {

  // 🟢 FIX: Verificamos si la petición original era el Login para NO recargar la página
  const isAuthEndpoint = error.config?.url?.includes('/auth/login');

  // 1. Manejo de Token Expirado (Solo si NO es la ruta de login)
  if (error.response?.status === 401 && !isAuthEndpoint) {
    console.error("Token expirado o inválido. Cerrando sesión...");
    localStorage.removeItem('vnext_auth_token');
    localStorage.removeItem('vnext_user');
    window.location.href = '/login';
    return Promise.reject(error);
  }

  // 2. 🟢 TRADUCCIÓN DE ERRORES ESTRUCTURADOS O PLANOS
  try {
    const state = useLanguageStore.getState();
    const t = state ? state.t : (key) => key;

    if (error.response && error.response.data && error.response.data.detail) {
      const detail = error.response.data.detail;

      // Si el backend envía la nueva estructura JSON (ej: {code: "ERR..."})
      if (typeof detail === 'object' && detail.code) {

        // ── Interceptar errores de quota/plan → modal global ──
        const _QUOTA_CODES = [
          'ERR_QUOTA_PIPELINE_EXCEEDED', 'ERR_NO_ACTIVE_SUBSCRIPTION',
          'ERR_AI_DAILY_LIMIT', 'ERR_WEBHOOKS_NOT_AVAILABLE',
          'ERR_SCRIPT_NOT_IN_PLAN', 'ERR_SCRIPT_QUOTA_EXCEEDED',
          'ERR_FORCE_REQUIRES_ACTIVE',
        ];
        const isQuotaErr = _QUOTA_CODES.includes(detail.code) || detail.code.startsWith('ERR_QUOTA_');
        if (isQuotaErr) {
          window.dispatchEvent(new CustomEvent('datiaflow:quota-error', {
            detail: { code: detail.code, params: detail.params || {} },
          }));
          error._quotaHandled = true;
          error.message = detail.code; // Clave técnica — el modal se encarga del UX
          return Promise.reject(error);
        }

        let translatedMessage = t(`errors.${detail.code}`, detail.params || {});

        if (!translatedMessage || translatedMessage === `errors.${detail.code}`) {
          translatedMessage = detail.fallback || 'Error desconocido';
        }

        // Interpolar {{key}} con params del backend (ej: {{motor}} → "MySQL")
        const params = detail.params || {};
        Object.entries(params).forEach(([key, value]) => {
          translatedMessage = translatedMessage.replace(
            new RegExp(`\\{\\{${key}\\}\\}`, 'g'),
            String(value)
          );
        });

        error.message = translatedMessage;
        return Promise.reject(error);
      }

      // 🟢 MANEJO DEL ERROR 422 DE FASTAPI (Detail es un Array)
      if (Array.isArray(detail)) {
        error.message = t('common.validation_error') || 'Faltan datos obligatorios o el formato es incorrecto.';
        return Promise.reject(error);
      }

      // 🟢 Si el backend envía un string plano (como lo hace tu auth.py actual), lo pasa directo
      error.message = typeof detail === 'string' ? detail : t('common.error_server');
      return Promise.reject(error);
    }
  } catch (e) {
    console.error("Error traduciendo mensaje:", e);
  }

  // Fallback de red
  if (!error.message) error.message = 'Error de conexión con el servidor.';
  return Promise.reject(error);
});